import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { SetupService } from 'src/app/core/services/setup/setup.service';
import { MustMatch } from './DesignMaster.mustmatch';
//import { icons } from '../data';
import { ActivatedRoute, Router } from '@angular/router';
import { formatDate } from '@angular/common';
import { format, parse } from 'path';
import { threadId } from 'worker_threads';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SessionCheck } from 'src/app/core/services/sessioncheck.service';

@Component({
  selector: 'app-DesignMaster',
  templateUrl: './DesignMaster.component.html',
  styleUrls: ['./DesignMaster.component.scss']
})

/**
 * Forms Validation component
 */
export class DesignMasterComponent implements OnInit {

  validationform: FormGroup; // bootstrap validation form
  SaleAcList: any = [];
  BillingAcList: any = [];
  ItemList: any = [];
  VoucherDetailList: any = [];
  PaymentTypes: any = [];
  validateTableRates: boolean = true;
  TotalItemQty: number;
  TotalItemAmount: number;
  FromEstimateVoucher : string;
  fileUploadInputs:any;
  fileExcel: DataTransfer;
  fileExcelUpload: any;
  fileBase64:any;
  fileBase64Back:any;
  fileName:string;
  fileType:string;

  constructor(public formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private toaster: ToastrService,
    private setup: SetupService,
    private route: ActivatedRoute,
    private router: Router,
    private modalService: NgbModal,
    private _session: SessionCheck
    //private _decimalPipe: DecimalPipe
  ) { }
  // bread crumb items
  breadCrumbItems: Array<{}>;

  // Form submition
  submit: boolean;
  formsubmit: boolean;
  typesubmit: boolean;
  rangesubmit: boolean;
  SearchItems: any = [];
  SearchPanelVisible: boolean;
  TotalQty: any;
  TotalAmount: any;
  EntryID: any;
  editMode: boolean;
  grandTotal: any = [];
  productTotal: any = [];
  AccountList: any = [];
  ProductArray: any = [];
  VoucherTypeList: any[];
  VoucherTypeCode: any[];
  EstimateData: any[];
  barCodeData:any;
  ngOnInit() {

    this.breadCrumbItems = [{ label: 'Forms' }, { label: 'Packing List', active: true }];
    this.EntryID = 0;
    this.EntryID = this.route.snapshot.queryParamMap.get('Id') ? this.route.snapshot.queryParamMap.get('Id') : '';
    this.FromEstimateVoucher= this.route.snapshot.queryParamMap.get('FromEstimate');
    this.EstimateData=JSON.parse(sessionStorage.getItem('EstimateSelectData'));
    this.editMode = false;
    this.PaymentTypes.push('TT');
    this.PaymentTypes.push('LC');
    /**
     * Bootstrap validation form data
     */
    this.validationform = this.formBuilder.group({
      BrandName: ['', [Validators.required]],
      StyleNo: ['', [Validators.required]],
      Gauge: ['', [Validators.required]],
      Timing: ['', [Validators.required]],
      SampleType: ['', [Validators.required]],
      SampleSize: ['', [Validators.required]],

    });
    var date = new Date();
    date.setDate(date.getDate());

    this.submit = false;
    this.formsubmit = false;
    this.typesubmit = false;
    this.rangesubmit = false;

    this.setVoucherList();
    if(this._session.getSessionStorage('doprint'))
    {this.barCodeData=JSON.parse(this._session.getSessionStorage('doprint'));


    if(this.barCodeData.length>0)
    {
      this.editRecordBarCode();
    }
  }
  else if(this.EntryID>0)
{
  this.editRecord(this.EntryID);
}
else{
  this.addBlankRow();
}
}

  setVoucherList() {
    //this.addBlankRow();
  }

  addBlankRow() {
    this.VoucherDetailList.push(
      {
        ROW_NO: this.VoucherDetailList.length + 1,
        ColourName: '',
        CountDesc: '',
        Content: '',
        ShadeNo: '',
        ConsQty: 0,
        S_NO: 0,
        id: 0,
      }
    );
  }
  checkLastRow(index) {
    // item.UN_CODE = event.UN_CODE;
    // item.UOM = event.UnitName;
    // item.RATE = event.Sale_Rate;
    // this.calculateProductAmount(event, item);
    if (index == this.VoucherDetailList.length - 1) {
      this.addBlankRow();
    }
  }
  get form() {
    return this.validationform.controls;
  }

  validSubmit() {
    this.submit = true;
    if (this.validationform.valid) {
      const VoucherDetailList2 = this.VoucherDetailList.filter(r => r.ColourName != "");
      if (VoucherDetailList2.length == 0 || VoucherDetailList2.length == undefined) {
        this.toaster.error('Please check List Items');
        return;
      }
      try {
        this.spinner.show();
        var JsonMaster = (this.validationform.value)
        JsonMaster.VType = '5001';
        JsonMaster.S_NO=this.EntryID;
        JsonMaster.Masterid=this.EntryID;
        JsonMaster.image=this.fileBase64;
        JsonMaster.imageBack=this.fileBase64Back;
        this.setup.AddMasterDetailData(JSON.stringify(JsonMaster),
         JSON.stringify(VoucherDetailList2))
          .subscribe({
            next(list) {
              fetchData(list);
            }
          });
        const fetchData = (data: any) => {
          this.spinner.hide();
          if (data.Status == 1) {
            this.toaster.success(data.ResponseMessage);
            this.router.navigate(['/entry/designList']);
          }
          else {
            this.toaster.error(data[0].ResponseMessage);
          }
        };
      } catch (error) {
        this.spinner.hide();
        console.log(error);
        this.toaster.error(error);
      }
    }
    else {
      this.toaster.error('Please enter required values');
    }
  }
  formSubmit() {
    this.formsubmit = true;

  }



  DeletePrdItem(item, iRowIndex) {
    this.VoucherDetailList.splice(iRowIndex, 1);
  }
  editRecord(EntryID) {
    try {
      this.setup.GetRecordInfo(this.EntryID, 'sp_getEditRecord', 'DesignMaster')
        .subscribe({
          next(list) {
            fetchData(list);
          }
        });
      const fetchData = (data: any) => {
        this.spinner.hide();
        if (data.ResultSets.length > 0) {
          this.fillEditRecordData(data);
        }
      };
    } catch (error) {
      this.spinner.hide();
      console.log(error);
      this.toaster.error(error);
    }

  }
  editRecordBarCode() {
    console.log(this.barCodeData);
    try {
      this.setup.GetBarCodeRecordInfo(this.barCodeData, 'sp_getEditRecord_BarCode', 'DesignMasterBC')
        .subscribe({
          next(list) {
            fetchData(list);
          }
        });
      const fetchData = (data: any) => {
        this.spinner.hide();
        if (data.ResultSets.length > 0) {
          this.fillEditRecordData(data);
        }
      };
    } catch (error) {
      this.spinner.hide();
      console.log(error);
      this.toaster.error(error);
    }

  }

  fillEditRecordData(data) {
    data.ResultSets[0].forEach(element => {
      var keys = Object.keys(element);
      console.log(keys);
      keys.forEach(e => {
        try {
          this.validationform.controls[e].setValue(element[e]);
        }
        catch (error) {
          console.log(error);

        }
      })
    });
    this.editMode = true;
    //this.selectedAccID = data[0].BAc_Code;
    this.VoucherDetailList = [];
    this.VoucherDetailList = data.ResultSets[1];
    this.addBlankRow();
    this.calcTotalBillAmt();


    const reader = new FileReader();
    const path:any="https://manglam.solutionera.in/mg_images/2.jpg";
    this.toDataURL(
      'https://mgapi.solutionera.in/mg_images3/'+  this.EntryID + '.jpg',
      function (dataUrl) {
        console.log(dataUrl);
       accessionBatchExcel(dataUrl);
      }

    );

  const accessionBatchExcel = (base64: any) => {
      this.fileBase64 = base64;
    }




    const reader2 = new FileReader();
    const path2:any="https://manglam.solutionera.in/mg_images/2.jpg";
    this.toDataURL(
      'https://mgapi.solutionera.in/mg_images3/'+  this.EntryID + '_b.jpg',
      function (dataUrl) {
        console.log(dataUrl);
       accessionBatchExcel2(dataUrl);
      }

    );

  const accessionBatchExcel2 = (base64: any) => {
      this.fileBase64Back = base64;
    }


  }
  calculateProductAmount(event, item) {
    item.QTY = +(+item.Case_Qty * +item.PcsPerBox).toFixed(2);
    item.AMOUNT = (item.RATE * item.QTY).toFixed(2);
    this.calcTotalBillAmt();
  }

  calcTotalBillAmt() {
    this.TotalItemQty = 0;
    this.TotalItemAmount = 0;
    for (let i = 0; i <= this.VoucherDetailList.length - 1; i++) {
      var element = this.VoucherDetailList[i];
      this.TotalItemQty += element.ConsQty;
    }
  }
  uploadExcel(event: any, content): void {

    try {
      this.spinner.show();
      this.fileExcel = <DataTransfer>event.target;
      this.fileExcelUpload = this.fileExcel.files;
      this.fileName = this.fileExcel.files[0].name;
      this.fileType = this.fileExcel.files[0].type;
      var ext = this.fileName.split('.')
      const reader = new FileReader();
      reader.readAsDataURL(this.fileExcelUpload[0]);
      reader.onload = function () {
        if (reader.result) {
          const base64 = reader.result.toString();
          accessionBatchExcel(base64);
        }
      }
      const accessionBatchExcel = (base64: any) => {
        this.fileBase64 = base64;
      }
    } catch (error) {

    }
  }
  uploadExcelBack(event: any, content): void {

    try {
      this.spinner.show();
      this.fileExcel = <DataTransfer>event.target;
      this.fileExcelUpload = this.fileExcel.files;
      this.fileName = this.fileExcel.files[0].name;
      this.fileType = this.fileExcel.files[0].type;
      var ext = this.fileName.split('.')
      const reader = new FileReader();
      reader.readAsDataURL(this.fileExcelUpload[0]);
      reader.onload = function () {
        if (reader.result) {
          const base64 = reader.result.toString();
          accessionBatchExcel(base64);
        }
      }
      const accessionBatchExcel = (base64: any) => {
        this.fileBase64Back = base64;
      }
    } catch (error) {

    }
  }
  openModal(largeDataModal: any) {
    this.modalService.open(largeDataModal, { size: 'lg' });
  }
  toDataURL(url, callback) {
    var xhr = new XMLHttpRequest();
    xhr.onload = function () {
      var reader = new FileReader();
      reader.onloadend = function () {
        callback(reader.result);
      };
      reader.readAsDataURL(xhr.response);
    };
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.send();
  }
}
